import { GsFormField, GsFormSchema } from 'libs/shared/src/components';
import { PictureDisplayMode } from '../../../models';
import { DEFAULT_CONFIG } from '../../../services/config/default.config';
import { BASIC_SCHEMA_FIELDS } from '../basics';
import { pictureDisplayModeSchemaFor } from '../basics/picture-display-mode.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { SPACING_SCHEMA } from './spacing.schema';

export const WATCHLIST_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    {
      formControlName: 'newForDays',
      label: 'components.watchlist.schema.newForDays',
      type: 'number',
      default: 10,
      min: 1
    },
    {
      formControlName: 'showPicture',
      label: 'components.watchlist.schema.showPicture',
      type: 'checkbox',
      default: true,
      groupingName: 'Products'
    },
    {
      ...pictureDisplayModeSchemaFor('pictureDisplayMode', undefined, undefined, 'Products'),
      // Cut keeps the previous hard-coded object-cover as default
      default: PictureDisplayMode.Cut,
      if: {
        args: [{ formControlName: 'showPicture', value: true }]
      }
    } as GsFormField<never>,
    {
      formControlName: 'showOrderButton',
      label: 'components.watchlist.schema.showOrderButton',
      type: 'checkbox',
      default: true,
      groupingName: 'Products'
    },
    {
      formControlName: 'showShareButton',
      label: 'components.watchlist.schema.showShareButton',
      type: 'checkbox',
      default: true,
      groupingName: 'Buttons'
    },
    {
      formControlName: 'showAddAllToCartButton',
      label: 'components.watchlist.schema.showAddAllToCartButton',
      type: 'checkbox',
      default: true,
      groupingName: 'Buttons'
    },

    // Button settings (nested under 'buttons' property)
    {
      formControlName: 'buttons',
      label: 'components.watchlist.schema.buttons',
      type: 'group',
      expandable: true,
      default: DEFAULT_CONFIG.uiElements?.buttons ?? {},
      fields: buttonSchemaFields()
    }
  ]
};
